module.exports = __webpack_public_path__ + "img/changzhou_center.3f397d54.jpg";